export default __webpack_public_path__ + "static/media/teachingresources.c00cc0c3.svg";